export default __webpack_public_path__ + "static/media/chores-desktop.8645d362.png";